/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Activity_Billing_BandInputs */



/**
* | output |
* | --- |
* | "Titan's size moved with the member count" |
*
* @param {Activity_Billing_BandInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const activity_billing_band = /** @type {((inputs?: Activity_Billing_BandInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Activity_Billing_BandInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("Размер тарифа Titan изменён вслед за числом участников")
	return /** @type {LocalizedString} */ ("Titan's size moved with the member count")
});